import { classToPlain } from 'class-transformer'
import { unparse, download } from 'papaparse'

export class CSVModelInterface {
  error = false
  filename = null
  staticTemplate: {downloadedFileName: string; fileType: string; templateCategory: string} = null
  static example () {
    const model = new this()
    const filename = model.filename || this.name
    const template = classToPlain(new this(), { strategy: 'excludeAll' })
    const csvData = unparse([template])
    const blob = new Blob([csvData], { type: 'text/csv' })
    download(blob, filename)
  }

  static usedStaticTemplate () {
    const model = new this()
    return model.staticTemplate
  }
}
